import { triggerCustomEvent, featureEnabled } from 'lib/helpers';
import {
  sendTrackingEvent,
  trackCompleteEvent,
  findCategoryByElement,
  NEW_ANALYTICS_FEATURE,
} from 'components/analytics/conversions/tracking';
import { JOIN_PRO_CLICK, JOIN_PRO_COMPLETE } from 'components/analytics/conversions/constants/actions';
import events from 'lib/events';
import EzModalController from 'layouts/modal/modal-controller';

export default class LicenseSelectorFreeModalController extends EzModalController {
  connect() {
    triggerCustomEvent(events.show_page.license_selector_free_modal_connects);
    super.connect();
  }

  close = (event) => {
    triggerCustomEvent(events.show_page.license_selector_free_modal_closes);
    super.close(event);
  }

  sendFreeLicenseEvent() {
    triggerCustomEvent(events.show_page.license_selector_free_modal_free_button, {
      licenseType: 'free_license',
    });
    triggerCustomEvent(events.download_btn.match_eezycore_free_dupe);
  }

  sendProLicenseEvent(event) {
    if (featureEnabled(NEW_ANALYTICS_FEATURE)) {
      const category = findCategoryByElement(event.target);

      sendTrackingEvent({
        element: event.target,
        data: { action: JOIN_PRO_CLICK, category },
      });

      trackCompleteEvent({
        action: JOIN_PRO_COMPLETE,
        category,
      });
    }

    triggerCustomEvent(events.show_page.license_selector_free_modal_pro_button, {
      licenseType: 'pro_license',
    });
  }

  sendCopyAttrEvent() {
    triggerCustomEvent(events.show_page.attribution_link_copied);
  }

  sendLearnMoreEvent() {
    triggerCustomEvent(events.show_page.license_selector_free_modal_learn_more);
  }
}
